import { useState, useEffect } from "react";
import { Menu, X, Download } from "lucide-react";

const links = [
  { label: "Storefront", href: "#storefront" },
  { label: "Command Center", href: "#command-center" },
  { label: "Growth", href: "#growth" },
  { label: "Customers", href: "#customers" },
  { label: "Advantage", href: "#advantage" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-[background-color,box-shadow] duration-500 backdrop-blur-xl ${
        scrolled ? "bg-[#0b0f19]/80 shadow-[0_8px_32px_rgba(0,0,0,0.4)]" : "bg-[#0b0f19]/40"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <span className="w-11 h-11 rounded-full bg-white p-1.5 shadow-[0_0_24px_rgba(251,191,36,0.25)] group-hover:shadow-[0_0_36px_rgba(251,191,36,0.45)] transition-shadow duration-500">
            <img src="/gromza-logo.png" alt="Gromza logo" className="w-full h-full object-contain" />
          </span>
          <span className="font-display text-xl font-semibold tracking-tight">
            Gromza<span className="text-amber-400">.</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-sm text-slate-300 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#download"
            data-testid="nav-download-button"
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-6 py-2.5 text-sm font-semibold text-[#0b0f19] hover:bg-amber-300 hover:shadow-[0_0_32px_rgba(251,191,36,0.4)] transition-[background-color,box-shadow] duration-300"
          >
            <Download size={16} /> Download App
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-slate-200"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0b0f19]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => setOpen(false)}
              className="block text-base text-slate-200 hover:text-amber-400 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#download"
            data-testid="nav-mobile-download-button"
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-6 py-2.5 text-sm font-semibold text-[#0b0f19]"
          >
            <Download size={16} /> Download App
          </a>
        </div>
      )}
    </header>
  );
};
